<template>
  <div class="wr-sjz">
    <el-dialog :visible.sync="searchVisible"
               :close-on-click-modal='false'
               :before-close="cancelGoods"
               title="备件选择"
               width="990px">
      <el-form :model="dataForm2"
               :inline="true"
               ref="dataForm2"
               class="demo-form-inline"
               label-width="160px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="物品编码："
                          prop="userMobile">
              <label>
                <el-input v-model="dataForm2.custGoodsCode"
                          placeholder="请输入物品编码"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="物品名称："
                          prop="userMobile">
              <label>
                <el-input v-model="dataForm2.goodsName"
                          placeholder="请输入物品名称"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="物品规格："
                          prop="userMobile">
              <label>
                <el-input v-model="dataForm2.specification"
                          placeholder="请输入物品规格"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="物品型号："
                          prop="userMobile">
              <label>
                <el-input v-model="dataForm2.model"
                          placeholder="请输入物品型号"
                          style="width:180px !important"
                          clearable></el-input>
              </label>
            </el-form-item>
          </el-col>
          <el-button @click="handleCode()">查询</el-button>
        </el-row>
        <el-table :data="goodsList"
                  border
                  v-loading="dataListLoading"
                  @selection-change="selectionChangeHandle"
                  style="width: 100%;">
          <el-table-column type="index"
                           label="序号"
                           width="50"></el-table-column>
          <el-table-column prop="oldGoodsCode"
                           header-align="center"
                           align="left"
                           width="150"
                           label="物品编码">
          </el-table-column>
          <el-table-column prop="oldGoodsName"
                           header-align="center"
                           align="left"
                           label="物品名称">
          </el-table-column>
          <el-table-column prop="oldSpecification"
                           header-align="center"
                           align="left"
                           label="规格">
          </el-table-column>
          <el-table-column prop="oldModel"
                           header-align="center"
                           align="left"
                           label="型号">
          </el-table-column>
          <!-- <el-table-column prop="oldEdition"
                           header-align="center"
                           align="center"
                           label="版本">
          </el-table-column>
          <el-table-column prop="oldConfiguration"
                           header-align="center"
                           align="center"
                           label="配置">
          </el-table-column> -->
          <el-table-column prop="oldBrand"
                           header-align="center"
                           align="center"
                           label="品牌">
          </el-table-column>
          <el-table-column prop="oldRemark"
                           header-align="center"
                           align="center"
                           label="备注">
          </el-table-column>
          <el-table-column fixed="right"
                           header-align="center"
                           align="center"
                           label="操作"
                           width="80">
            <template slot-scope="scope">
              <el-button type="text"
                         size="small"
                         @click="confirmAdd(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="addFunc">
        <div class="addCancel"
             @click="cancelGoods">取消</div>
        <!-- <div class="addConfirm" :class="subLoading?'but-loading':''" @click="confirmAdd">
            <i class="el-icon-loading" v-if="subLoading"></i>
            确定
        </div> -->
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visible"
               :close-on-click-modal='false'
               :before-close="cancelAdd"
               title="领用超量原因"
               width="800px">
      <el-form :model="dataForm"
               :inline="true"
               ref="dataForm"
               label-width="160px"
               class="demo-form-inline">
        <el-row>
          <el-col :span="24">
            <el-form-item label="请填写领用超量原因："
                          prop="userName">
              <label>
                <el-input type="textarea"
                          maxlength="200"
                          placeholder="当前领用数量高于备件数量，请输入领用超量原因(不超过200字)..."
                          v-model="exceedReason"
                          style="width:500px !important"
                          :rows="3"></el-input>
              </label>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btns">
          <el-button type="primary"
                     class="btn-check"
                     @click="handleSaveReason()"
                     :class="subLoading?'but-loading':''">确认</el-button>
          <el-button type="primary"
                     @click="cancelAdd()"
                     :class="subLoading?'but-loading':''">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <div class="container">
      <!-- 面包屑 -->
      <!-- <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('myInfo')">个人中心</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareGetList')">联储联备</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareGetList')">备件领用</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">备件领用单详情</div>
      </div> -->
      <div class="sjz"
           style="width:100%">
        <div :class="index===(steps.length-1)?'sjz-item':'sjz-kuaikuai'"
             v-for="(item, index) in steps"
             :key="index">
          <div class="sjz-item">
            <div :class="'sjz-icon '+ ((index === activeIndex) ? 'sjz-doing' : ((index > activeIndex) ? 'sjz-done' : ''))">
              <i class="el-icon-check"
                 style="width:40px;height:40px;"
                 v-if="index<activeIndex"></i>
              <span class="sjc-num sjc-do"
                    v-else-if="index===activeIndex">{{index+1}}</span>
              <span class="sjc-num"
                    v-else-if="index>activeIndex">{{index+1}}</span>
            </div>
            <div :class="'word-icon '+ ((index === activeIndex) ? 'word-do' : ((index > activeIndex) ? 'word-undone' : ''))">{{item.name}}</div>
          </div>
          <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
               v-if="index!==(steps.length-1)"></div>
        </div>
      </div>
      <div class="body-info">
        <el-form :model="dataForm"
                 :inline="true"
                 ref="dataForm"
                 label-width="130px"
                 style="margin-top:130px"
                 class="demo-form-inline"
                 v-if="detailInfo">
          <!-- 地址 -->
          <address-detail @myEvent="handleAddress"
                          :isOrder="true"
                          ref="addressDetail"></address-detail>
          <!-- 发票 -->
          <!-- <invoice-list :chooseId="dataForm.orderInvoiceId" @change="changeInvoice"></invoice-list> -->
          <div style="position:relative;">
            <h3 style="display: inline-block;"
                class="spareInfo">基本信息</h3>
            <!-- <span style="position:absolute;right:30px;top:10px;padding:5px 20px;font-size: 14px;color: #333333;" v-if="detailInfo">
          领用单状态：
          <span v-if="detailInfo.status === '0'" style="color: #1D65A8;">已提交</span>
          <span v-if="detailInfo.status === '1'" style="color: #1D65A8;">发货中</span>
          <span v-if="detailInfo.status === '2'" style="color: #1D65A8;">已签收</span>
          <span v-if="detailInfo.status === '3'" style="color: #1D65A8;">已取消</span>
        </span> -->
          </div>
          <el-row v-if="userInfo">
            <el-col :span="9"
                    class="row-height">
              <el-form-item label="公司名称："
                            prop="userCompany">
                <label>{{ userInfo.customerName }}</label>
              </el-form-item>
            </el-col>
            <el-col :span="9"
                    class="row-height">
              <el-form-item label="收件人："
                            prop="applyTime">
                <label>{{ dataForm.receiveUser}}</label>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    class="row-height">
              <el-form-item label="联系电话："
                            prop="applyTime">
                <label>{{ dataForm.receivePhone}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="userInfo">
            <el-col :span="24"
                    class="row-height row-margin">
              <el-form-item label="收件地址："
                            prop="applyTime">
                <label>{{ dataForm.receiveAddress}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="invoiceList.length">
            <el-col :span="24"
                    class="row-margin">
              <el-form-item label="发票信息："
                            prop="invoiceList">
                <el-table ref="apyTable"
                          :data="invoiceList"
                          size="small"
                          border
                          highlight-current-row>
                  <el-table-column label="发票抬头"
                                   header-align="center">
                    <template slot-scope="{row}">
                      <span :label="row.companyName">{{row.companyName}}</span>
                      <span v-if="row.defaultFlag === '10'"
                            class="default-flag">默认</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="invoiceObjType"
                                   label="发票类型"
                                   align="center"
                                   width="150">
                    <template slot-scope="{row}">
                      {{row.invoiceObjType === '10' ? '普通发票' : '专用发票'}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="taxpayerIdentity"
                                   label="税务登记证号"
                                   align="center"
                                   width="150"></el-table-column>
                  <el-table-column prop="bankAccountNo"
                                   label="基本开户账号"
                                   align="center"
                                   width="160"></el-table-column>
                  <el-table-column prop="companyPhone"
                                   label="固定电话"
                                   align="center"
                                   width="120"></el-table-column>
                  <el-table-column prop="openingBank"
                                   label="开户银行名称"
                                   align="center"
                                   width="200"></el-table-column>
                  <el-table-column prop="companyAddress"
                                   label="注册场所地址"
                                   header-align="center"
                                   width="200"></el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
                    class="row-date">
              <el-form-item prop="userName">
                <span slot="label"><i class="icon-red">*</i>要求到货日期：</span>
                <label>
                  <el-date-picker v-model="dataForm.expectDeliveryDate"
                                  type="date"
                                  placeholder="选择日期"
                                  value-format="yyyy-MM-dd"
                                  :disabled="detailInfo && detailInfo.orderStatus !== '10'"
                                  :picker-options="pickerOptions1"
                                  clearable>
                  </el-date-picker>
                </label>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
          <el-form-item label="是否加急：" prop="userCompany">
            <label>
                <el-radio v-model="dataForm.expedited" label="1" :disabled="detailInfo && detailInfo.status !== '0'">是</el-radio>
                <el-radio v-model="dataForm.expedited" label="0" :disabled="detailInfo && detailInfo.status !== '0'">否</el-radio>
            </label>
          </el-form-item>
        </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注："
                            prop="userMobile">
                <label>
                  <el-input type="textarea"
                            maxlength="200"
                            v-model="dataForm.remarks"
                            placeholder="请输入备注(不超过200字)..."
                            :disabled="detailInfo.orderStatus !== '10'"
                            style="width:800px !important;"
                            :rows="3"></el-input>
                </label>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row v-if="userInfo">
        <el-col :span="24">
          <el-form-item label="领用日期：" prop="applyTime">
            <label>{{ dataForm.applyTime}}</label>
          </el-form-item>
        </el-col>
      </el-row> -->
          <!-- <el-row v-if="userInfo">
        <el-col :span="12">
          <el-form-item label="客户负责人：" prop="userMobile">
            <label>{{userInfo.customerLeaderName}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="userCompany">
            <label>{{ userInfo.customerLeaderMobile }}</label>
          </el-form-item>
        </el-col>
      </el-row> -->
          <h3 style="display: inline-block;"
              class="spareInfo">发票信息</h3>
          <el-row v-if="invoiceList.length">
            <el-table ref="apyTable"
                      :data="invoiceList"
                      size="small"
                      border
                      highlight-current-row>
              <el-table-column label="发票抬头"
                               header-align="center">
                <template slot-scope="{row}">
                  <span :label="row.companyName">{{row.companyName}}</span>
                  <span v-if="row.defaultFlag === '10'"
                        class="default-flag">默认</span>
                </template>
              </el-table-column>
              <el-table-column prop="invoiceObjType"
                               label="发票类型"
                               align="center"
                               width="150">
                <template slot-scope="{row}">
                  {{row.invoiceObjType === '10' ? '普通发票' : '专用发票'}}
                </template>
              </el-table-column>
              <el-table-column prop="invoiceObjType"
                               label="开票对象"
                               align="center">
                <template slot-scope="{row}">
                  {{row.invoiceObjType === '10' ? '个人' : '单位'}}
                </template>
              </el-table-column>
              <el-table-column prop="taxpayerIdentity"
                               label="税务登记证号"
                               align="center"
                               width="150"></el-table-column>
              <el-table-column prop="bankAccountNo"
                               label="基本开户账号"
                               align="center"
                               width="160"></el-table-column>
              <el-table-column prop="companyPhone"
                               label="固定电话"
                               align="center"
                               width="120"></el-table-column>
              <el-table-column prop="openingBank"
                               label="开户银行名称"
                               align="center"
                               width="200"></el-table-column>
              <el-table-column prop="companyAddress"
                               label="注册场所地址"
                               header-align="center"
                               width="200"></el-table-column>
              <el-table-column prop=""
                               min-width="200"
                               label="收票人/联系人/地址">
                <template slot-scope="{row}">
                  {{(row.consignee || '') + '/' + (row.contactInformation || '') + '/' + (row.mailingAddress || '')}}
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="detail_row flex-between">
              <div class="detail_row item_col">
                <label class="flex-shrink">发票抬头：</label>
                <div>{{invoiceList[0].companyName || ''}}</div>
              </div>
              <div class="detail_row item_col">
                <label class="flex-shrink">税务登记证号：</label>
                <div>{{invoiceList[0].taxpayerIdentity || ''}}</div>
              </div>
              <div class="detail_row">
                <label class="flex-shrink">基本开户账号：</label>
                <div class="">{{invoiceList[0].bankAccountNo || ''}}</div>
              </div>
            </div>
            <div class="detail_row flex-between">
              <div class="detail_row item_col">
                <label class="flex-shrink">发票类型：</label>
                <div>{{(invoiceList[0].invoiceType ===  '10' ? '普通发票' : '专用发票')}}</div>
              </div>
              <div class="detail_row item_col">
                <label class="flex-shrink">注册场所地址：</label>
                <div>{{invoiceList[0].companyAddress || ''}}</div>
              </div>
              <div class="detail_row">
                <label class="flex-shrink">注册固定电话：</label>
                <div class="">{{invoiceList[0].companyPhone || ''}}</div>
              </div>
            </div> -->
          </el-row>
          <h3 style="display: inline-block;"
              class="spareInfo">领用物品</h3>
          <el-row class="two-btns">
            <el-button type="primary"
                       :disabled="detailInfo.orderStatus !== '10'"
                       style="background:#1D65A8;color:#fff;border-color:#1D65A8"
                       @click="addNew()">手工增行</el-button>
          </el-row>
          <el-row style="margin-bottom:30px;">
            <el-table :data="dataList"
                      border
                      v-loading="dataListLoading"
                      style="width: 100%;">
              <el-table-column type="index"
                               width="50"
                               label="序号"></el-table-column>
              <el-table-column prop="oldGoodsCode"
                               header-align="center"
                               align="center"
                               label="物品编码"
                               width="150"
                               show-overflow-tooltip>
                <!-- <template slot-scope="scope">
              <el-input placeholder="请输入物品编码" v-model="scope.row.goodsCode" :disabled="true"></el-input>
          </template> -->
              </el-table-column>
              <el-table-column prop="oldGoodsName"
                               header-align="center"
                               align="center"
                               label="物品名称"
                               show-overflow-tooltip>
                <!-- <template slot-scope="scope">
              <el-select :disabled="detailInfo && detailInfo.status !== '0'" v-model="scope.row.goodsName" clearable placeholder="请选择名称" @change="selectName($event, scope.$index)">
              <el-option v-for="item in nameList"
                :key="item.goodsName" :label="item.goodsName" :value="item"></el-option>
            </el-select>
          </template> -->
              </el-table-column>
              <el-table-column prop="oldSpecification"
                               header-align="center"
                               align="center"
                               label="规格"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldModel"
                               header-align="center"
                               align="center"
                               label="型号"
                               show-overflow-tooltip>
              </el-table-column>
              <!-- <el-table-column prop="oldEdition"
                               header-align="center"
                               align="center"
                               label="版本"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldConfiguration"
                               header-align="center"
                               align="center"
                               label="配置"
                               show-overflow-tooltip>
              </el-table-column> -->
              <el-table-column prop="goodsPrice"
                               header-align="center"
                               align="center"
                               label="单价"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldBrand"
                               header-align="center"
                               align="center"
                               label="品牌"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldRemark"
                               header-align="center"
                               align="center"
                               label="备注"
                               show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-input :disabled="detailInfo && detailInfo.orderStatus !== '10'"
                            placeholder="请输入备注"
                            v-model="scope.row.remark"
                            clearable
                            maxlength="300"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="safetyStockQuantity"
                               header-align="center"
                               align="center"
                               label="备件数量"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="goodsNum"
                               header-align="center"
                               align="center"
                               label="领用数量"
                               show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-input :disabled="detailInfo && detailInfo.orderStatus !== '10'"
                            placeholder="请输入领用数量"
                            maxlength="7"
                            v-model="scope.row.goodsNum"
                            clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column fixed="right"
                               header-align="center"
                               align="center"
                               label="操作"
                               width="80">
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             @click="openDialogHandle(scope.row,scope.$index)"
                             :disabled="detailInfo && detailInfo.orderStatus !== '10'">修改</el-button>
                  <el-button type="text"
                             size="small"
                             @click="deleteHandle(scope.row,scope.$index)"
                             :disabled="detailInfo && detailInfo.orderStatus !== '10'">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row v-if="exceedReason">
            <el-col :span="24">
              <el-form-item label="领用超量原因："
                            prop="exceedReason">
                <label>
                  <el-input type="textarea"
                            v-model="exceedReason"
                            placeholder="请输入领用超量原因..."
                            :disabled="detailInfo.orderStatus !== '10'"
                            style="width:800px !important;"
                            :rows="3"></el-input>
                </label>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="row"
               style="display:flex;justify-content: center;margin-top:20px"
               v-if="detailInfo && (detailInfo.orderStatus === '10')">
            <div v-if="detailInfo.orderStatus === '10'"
                 :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="margin-right:10px;"
                 @click="handleCancel()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              取消领用单
            </div>
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff"
                 @click="handleSave()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              确定
            </div>
          </div>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { fomatDateTime } from '@/utils'
import AddressDetail from './addressDetail.vue'
import InvoiceList from './invoice.vue'
export default {
  data () {
    return {
      dataForm: {
        id: '',
        dateValue: '',
        expedited: '1',
        name: '',
        remarks: '',
        expectDeliveryDate: '',
        receiveUser: '',
        receiveAddress: '',
        orderInvoiceId: '', // 发票id
        receivePhone: ''
      },
      invoiceList: [], // 发票列表
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      exceedReason: '',
      customerCode: '',
      addressId: '',
      userInfo: null,
      detailInfo: null,
      userId: '',
      nameList: [],
      addressList: [],
      gogo: true,
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      subLoading: false, // 按钮加载中
      subFlag: false, // 提交成功
      searchVisible: false,
      dataForm2: {
        specification: '',
        edition: '',
        goodsName: '',
        custGoodsCode: '', // 用户物品编码
        model: '' // 型号
      },
      goodsList: [],
      currentIndex: '',
      activeIndex: 0,
      steps: [
        {
          ind: 1,
          key: '',
          name: '提交领用',
          time: ''
        },
        {
          ind: 2,
          key: '',
          name: '仓储受理',
          time: ''
        },
        {
          ind: 3,
          key: '',
          name: '物流配送',
          time: ''
        },
        {
          ind: 4,
          key: '',
          name: '完成',
          time: ''
        },
        {
          ind: 5,
          key: '',
          name: '完成评价',
          time: ''
        }
      ]
    }
  },
  mounted () {
    // this.getUserInfo()
    this.getInfo()
  },
  components: {
    AddressDetail,
    InvoiceList
  },
  methods: {
    handleCode () {
      this.dataListLoading = true
      let params = {
        companyId:
          localStorage.getItem('defaultCompanyId') !== ''
            ? localStorage.getItem('defaultCompanyId')
            : null,
        oldSpecification: this.dataForm2.specification,
        oldGoodsName: this.dataForm2.goodsName,
        oldGoodsCode: this.dataForm2.custGoodsCode,
        oldModel: this.dataForm2.model
      }
      this.$http
        .post(`/front/order/lclb/receive/getSparePartsDetailByOrdinary`, params)
        .then(({ data: res }) => {
          this.goodsList = res.data
          this.dataListLoading = false
        })
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    confirmAdd (row) {
      let goodsCode = row.oldGoodsCode
      let goodsName = row.oldGoodsName
      let specification = row.oldSpecification
      let model = row.oldModel
      let edition = row.oldEdition
      let configuration = row.oldConfiguration
      let safetyStockQuantity = row.safetyStockQuantity
      let brand = row.oldBrand
      let remark = row.oldRemark
      // this.dataForm2.edition = rowEdition
      this.dataList[this.currentIndex].oldConfiguration = configuration
      this.dataList[this.currentIndex].oldEdition = edition
      this.dataList[this.currentIndex].oldGoodsCode = goodsCode
      this.dataList[this.currentIndex].oldGoodsName = goodsName
      this.dataList[this.currentIndex].oldSpecification = specification
      this.dataList[this.currentIndex].oldModel = model
      this.dataList[this.currentIndex].safetyStockQuantity =
        safetyStockQuantity
      this.dataList[this.currentIndex].oldBrand = brand
      this.dataList[this.currentIndex].oldRemark = remark
      this.dataList = [...this.dataList]
      this.searchVisible = false
    },
    // 查询物料信息
    openDialogHandle (row, index) {
      this.dataForm2.goodsCode = ''
      this.dataForm2.specification = ''
      this.dataForm2.model = ''
      this.dataForm2.goodsName = ''
      this.goodsList = []
      this.currentIndex = index
      this.searchVisible = true
    },
    cancelGoods () {
      this.searchVisible = false
    },
    // 获取当前登录信息
    getUserInfo () {
      this.$http
        .get(`${window.SITE_CONFIG['baseURL']}/sys/user/info`)
        .then((data) => {
          // console.log(data)
          if (data && data.code === '1') {
            this.userInfo = data.result.user
            this.userId = data.result.user.userId
            this.customerCode = data.result.user.customerCode
            this.getNameList()
          }
        })
    },
    cancelAdd () {
      this.visible = false
      this.exceedReason = ''
    },
    // 填写领用原因
    handleSaveReason () {
      this.visible = false
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        this.$router.push({ name: name })
      } else {
        this.resetData()
        this.$router.go(-1)
      }
    },
    handleAddress (id) {
      if (id) {
        this.addressId = id + ''
      } else {
        this.addressId = ''
      }
    },
    // 修改发票
    changeInvoice (id) {
      this.dataForm.orderInvoiceId = id + ''
    },
    // 手工增行
    addNew () {
      this.dataList.push({
        oldGoodsCode: '',
        oldGoodsName: '',
        oldSpecification: '',
        oldModel: '',
        oldRemark: '',
        oldConfiguration: '',
        oldEdition: '',
        oldBrand: '',
        goodsNum: ''
      })
    },
    deleteHandle (row, index) {
      if (this.dataList.length === 1) {
        this.$message.error('当前只有一条领用单，不能删除')
      } else {
        this.dataList.splice(index, 1)
      }
    },
    getNameList () {
      this.$http
        .get(
          `${window.SITE_CONFIG['baseURL']}/lclb/receive/getSparePartsDetail`,
          {
            params: {
              customerCode: this.customerCode
            }
          }
        )
        .then((data) => {
          if (data.result.code === 0) {
            this.nameList = data.result.data
          } else {
            this.nameList = []
          }
        })
    },
    getInfo () {
      this.invoiceList = []
      this.$http
        .get(`/front/order/lclb/receive/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.detailInfo = res.data
            this.dataList = res.data.receiveDetailList
            this.dataForm.expectDeliveryDate = res.data.expectDeliveryDate ? res.data.expectDeliveryDate.slice(
              0,
              10
            ) : null
            if (res.data.payOrderInvoiceVo) {
              this.invoiceList = [res.data.payOrderInvoiceVo]
              this.dataForm.orderInvoiceId = res.data.orderInvoiceId || ''
              // res.data.payOrderInvoiceVo.orderInvoiceId || ''
            } else {
              this.dataForm.orderInvoiceId = ''
            }
            this.dataForm.expedited = res.data.expedited
            this.dataForm.remarks = res.data.orderRemarks
            this.dataForm.applyTime = fomatDateTime(res.data.applyTime)
            this.addressId = res.data.addressId
            this.exceedReason = res.data.excessMemo
            if (res.data.addressVo) {
              this.dataForm.receiveUser = res.data.addressVo.receiveGoodsPerson
              this.dataForm.receivePhone = res.data.addressVo.receiveGoodsPhone
              this.dataForm.receiveAddress =
                res.data.addressVo.province +
                '-' +
                res.data.addressVo.city +
                '-' +
                res.data.addressVo.area +
                '-' +
                res.data.addressVo.address
            }
            //      {code:'0', value:'已提交'},
            // {code:'1', value:'发货中'},
            // {code:'2', value:'已签收'},
            // {code:'3', value:'已取消'}
            if (
              res.data.orderStatus === '10' ||
              res.data.orderStatus === '99'
            ) {
              this.activeIndex = 0
            }
            if (res.data.orderStatus === '31') {
              this.activeIndex = 2
            }
            if (
              res.data.orderStatus === '59' ||
              res.data.orderStatus === '41'
            ) {
              this.activeIndex = 3
            }
            if (res.data.applyTime) {
              this.steps[0].time = res.data.applyTime
            }
            if (res.data.confirmTime) {
              this.steps[1].time = res.data.confirmTime
            }
            if (res.data.deliveryTime) {
              this.steps[2].time = res.data.deliveryTime
            }
            if (res.data.finishTime) {
              this.steps[3].time = res.data.finishTime
            }
            if (res.data.signTime) {
              this.steps[4].time = res.data.signTime
            }
            this.$nextTick(() => {
              if (
                res.data.orderStatus === '59' ||
                res.data.orderStatus === '99' ||
                res.data.orderStatus === '30'
              ) {
                this.$refs.addressDetail.handleAddress(false)
              }
              this.$refs.addressDetail.init(res.data.addressId)
              if (
                res.data.orderStatus === '59' ||
                res.data.orderStatus === '99' ||
                res.data.orderStatus === '30'
              ) {
                this.$refs.addressDetail.isCancel = true
              }
            })
          } else {
            this.dataList = []
          }
        })
    },
    // 确认
    handleSave () {
      if (this.subLoading) {
        return false
      }
      var flag = true
      if (
        this.dataForm.expectDeliveryDate === '' ||
        this.dataForm.expectDeliveryDate === null
      ) {
        this.$message.warning(this.$t('message.emptyDate'))
        flag = false
      }
      if (this.dataList.length === 0) {
        this.$message.warning('请选择名称后进行添加')
        flag = false
      }
      if (
        this.addressId === '' ||
        this.addressId === null ||
        this.addressId === undefined
      ) {
        this.$message.warning('地址不能为空')
        flag = false
      }
      this.dataList.forEach((item) => {
        if (item.oldGoodsCode === '') {
          this.$message.warning('物品编码不能为空')
          flag = false
        }
        if (item.goodsNum === '') {
          this.$message.warning('领用数量不能为空')
          flag = false
        }
        if (!new RegExp('^[1-9]([0-9])*$').test(item.goodsNum)) {
          this.$message.warning('领用数量只能为大于0的正整数且不超过7位数')
          flag = false
        }
        if (
          !(
            item.oldGoodsName === '' ||
            item.oldGoodsName === undefined ||
            item.oldGoodsName === null
          )
        ) {
          if (!this.exceedReason) {
            // 超量原因为空
            if (item.goodsNum > item.safetyStockQuantity) {
              this.visible = true
              flag = false
            }
          } else {
            if (item.goodsNum <= item.safetyStockQuantity) {
              this.exceedReason = ''
            }
          }
        }
        if (
          item.oldGoodsName === '' ||
          item.oldGoodsName === undefined ||
          item.oldGoodsName === null
        ) {
          this.$message.warning('物品名称不能为空')
          flag = false
        }
      })
      if (flag) {
        this.subLoading = true
        this.$http
          .post(
            `/front/order/lclb/receive/updateByOrdinary`,
            {
              orderId: this.$route.query.id,
              expectDeliveryDate: this.dataForm.expectDeliveryDate,
              orderRemarks: this.dataForm.remarks,
              addressId: this.addressId,
              orderInvoiceId: this.dataForm.orderInvoiceId,
              excessMemo: this.exceedReason,
              expedited: this.dataForm.expedited,
              receiveDetailList: this.dataList
            }
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('更新成功')
              this.subLoading = false
              this.$router.push({ name: 'spareGetList' })
            } else {
              this.subLoading = false
            }
          })
          .catch(() => {
            this.subLoading = false
          })
      }
    },
    handleCancel () {
      this.subLoading = true
      this.$http
        .post(`/front/order/lclb/receive/cancel`, {
          orderId: this.$route.query.id
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success('取消成功')
            this.subLoading = false
            this.$router.push({ name: 'spareGetList' })
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 30px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.btns {
  margin-left: 230px;
}
.btn-check {
  margin-right: 30px;
}
.addressList {
  list-style: none;
}
.two-btns {
  margin-bottom: 10px;
}
.addFunc {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.addCancel {
  width: 158px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #1d65a8;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
}
.spareInfo {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 10px;
}
.inquiryfj {
  padding-left: 8px;
  display: flex;
  flex-wrap: wrap;
}
.inquiryfj li {
  padding-left: 5px;
  width: 100px;
  position: relative;
}
.inquiryfjx {
  position: absolute;
  right: 0px;
  top: 0;
  width: 20px;
  height: 20px;
}
.inquiryfj li img {
  width: 95px;
  height: 95px;
  cursor: pointer;
}
.inquiryfj li p {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  font-weight: bold;
}
.inqueryDetail {
  .el-textarea {
    width: 100%;
    min-width: 500px;
  }
  .good-link {
    cursor: pointer;
    color: #1d65a8;
    text-decoration: underline;
  }
  /deep/ .el-form-item__label {
    flex-grow: 0;
    flex-shrink: 0;
  }
  /deep/ .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: flex;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.icon-red {
  color: #f00;
  margin-right: 5px;
}
.row-height {
  height: 24px;
}
.row-margin {
  margin-bottom: 12px;
}
.row-date {
  height: 48px;
}
</style>
